export default {
  startingPitchers: {
    title: "Lanciatori partenti",
    tabs: {
      byPitcher: "Per lanciatore",
      allPitchers: "Tutti i lanciatori",
    },
    labels: {
      confirmed: "CONFERMATO",
      expected: "PREVISTO",
      pitcher: "LANCIATORE",
      tbd: "DA DEFINIRE",
    },
    empty: {
      title: "Nessun lanciatore partente disponibile",
    },
  },
};